/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Detail_Tab_TimelineInputs */

const en_case_detail_tab_timeline = /** @type {(inputs: Case_Detail_Tab_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timeline`)
};

const pt_br2_case_detail_tab_timeline = /** @type {(inputs: Case_Detail_Tab_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Histórico`)
};

/**
* | output |
* | --- |
* | "Timeline" |
*
* @param {Case_Detail_Tab_TimelineInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_detail_tab_timeline = /** @type {((inputs?: Case_Detail_Tab_TimelineInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Detail_Tab_TimelineInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_detail_tab_timeline(inputs)
	return pt_br2_case_detail_tab_timeline(inputs)
});